let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("hpePq"), load("aIbV9")]).then(() => parcelRequire('7wMxS'));